var map = {
	"./asset.svg": "7a53",
	"./big_asset.svg": "ab22",
	"./car.svg": "2ecc",
	"./company.svg": "f2f3",
	"./dating_style.svg": "dd84",
	"./document.svg": "b6ff",
	"./empty.svg": "d0d9",
	"./fast_car.svg": "ef35",
	"./heart.svg": "1de2",
	"./high_income.svg": "9b35",
	"./house.svg": "0d50",
	"./ideal.svg": "0324",
	"./identification.svg": "8c5c",
	"./identity.svg": "2b5b",
	"./income.svg": "cdae",
	"./job.svg": "a395",
	"./photo.svg": "97f5",
	"./school.svg": "f8b7",
	"./tag.svg": "c630",
	"./tie.svg": "4c03",
	"./university.svg": "bd54",
	"./very_high_income.svg": "7550"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2b92";